// extracted by mini-css-extract-plugin
export var logo = "_bl-2";
export var logoWrapper = "_bl-1";
export var strip = "_bl-0";